import { buildQuery } from "@/api/apiUtils";
import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
import type {
  IWorkerCreatePayload,
  IWorkerUpdatePayload,
  IWorkerListParams,
  IWorkerListResponse,
  IWorkerDetailResponse,
  IWorkerMutationResponse,
} from "@/interface/worker.model";

export const WorkerService = {
  createWorker: async (
    payload: IWorkerCreatePayload,
  ): Promise<IWorkerMutationResponse> => {
    return callApi<IWorkerMutationResponse>(API_ENDPOINT.createWorker, {
      method: "POST",
      data: payload,
    });
  },

  getWorkerList: async (
    params: IWorkerListParams = {},
  ): Promise<IWorkerListResponse> => {
    return callApi<IWorkerListResponse>(
      `${API_ENDPOINT.workerList}${buildQuery(params)}`,
      { method: "GET" },
    );
  },

  getWorkerDetail: async (workerId: string): Promise<IWorkerDetailResponse> => {
    return callApi<IWorkerDetailResponse>(
      API_ENDPOINT.workerDetail.replace(":workerId", workerId),
      { method: "GET" },
    );
  },

  updateWorker: async (
    workerId: string,
    payload: IWorkerUpdatePayload,
  ): Promise<IWorkerMutationResponse> => {
    return callApi<IWorkerMutationResponse>(
      API_ENDPOINT.workerUpdate.replace(":workerId", workerId),
      { method: "PUT", data: payload },
    );
  },

  deleteWorker: async (workerId: string): Promise<IWorkerMutationResponse> => {
    return callApi<IWorkerMutationResponse>(
      API_ENDPOINT.workerDelete.replace(":workerId", workerId),
      { method: "DELETE" },
    );
  },

  downloadBulkTemplate: async (): Promise<Blob> => {
    return callApi<Blob>(API_ENDPOINT.workerBulkTemplate, {
      method: "GET",
    });
  },

  bulkUploadWorkers: async (file: File): Promise<IWorkerMutationResponse> => {
    const formData = new FormData();
    formData.append("file", file);

    return callApi<IWorkerMutationResponse>(API_ENDPOINT.workerBulkUpload, {
      method: "POST",
      data: formData,
      multipart: true,
    });
  },
};
